<script setup lang="ts">
import VFormSwitchInput from '@modules/forms/components/inputs/VFormSwitchInput/VFormSwitchInput.vue';

import type { ITreeNodeLeafEmits, ITreeNodeLeafProps } from './types';

defineProps<ITreeNodeLeafProps>();
const emit = defineEmits<ITreeNodeLeafEmits>();
</script>

<template>
  <div v-data-qa-auto-id="'VTreeNodeLeaf'" class="flex items-center">
    <span class="w-full pl-2 pr-5 word-break sm:w-auto sm:min-w-[320px]">{{ node.label }}</span>
    <VFormSwitchInput
      class="h-[16px]"
      :disabled="isLoading"
      :value="value"
      @change="(isEnabled) => emit('change', node, isEnabled)"
    />
  </div>
</template>
